import {Component, DestroyRef, EventEmitter, inject, input, OnInit, Output, output} from '@angular/core';
import {ControlContainer, FormControl, FormGroup, Validators} from '@angular/forms';
import {BaseComponent} from '@ui-app/components/base.component';

@Component({
    selector: 'employee-base-field',
    standalone: true,
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: () => inject(ControlContainer, {skipSelf: true})
        }
    ],
    template: '',
    styles: ''
})
export class BaseFieldComponent extends BaseComponent implements OnInit{
    controlKey = input('');
    isRequired = input(true);
    //valueChange = output();
    @Output() valueChange = new EventEmitter<any>();

    parentContainer = inject(ControlContainer);
    selectedValue: string | number | undefined;
    defaultValue: string | string[] | number | number[] | undefined;

    protected controlValidators: Validators = [];
    protected destroyRef = inject(DestroyRef);
    constructor() {
        super()
    }

    get parentForm(): FormGroup {
        return this.parentContainer.control as FormGroup;
    }

    ngOnInit(): void {
        this.controlValidators = this.isRequired() ? [Validators.required] : [];
        this.defaultValue = this.parentForm.get(this.controlKey())?.value || null;
        this.initControl();
    }

    protected initControl(): void {
        this.patchOrInsertControl();
    }

    protected patchOrInsertControl(): void {
        if (this.defaultValue) {
            this.parentForm.patchValue({
                [this.controlKey()]: this.defaultValue,
            });
        } else {
            this.parentForm.addControl(this.controlKey(),
                new FormControl(this.defaultValue, this.controlValidators),
            );
        }
    }

    protected onSelectionChange(value: any): void {
    }

}
